export default __webpack_public_path__ + "static/media/Y'toth (dagger).4cabff05.jpg";